const defaultSubscriptionPrice = 1495


export default defaultSubscriptionPrice
